import React, { Component } from "react";
import { Modal, Spin, message } from "antd";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ButtonItem } from "../../../../Components/Items";
import "../cmms.css";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Muestra el PDF en el iframe con location.replace: pdf.open() navega el iframe y mete una
// entrada al historial, y despues el "Atras" de la pantalla (history.goBack) solo regresa el iframe.
export const mostrarPdfEnIframe = (pdf, iframe, urlAnterior) =>
    new Promise((resolve) => {
        if (!pdf || !iframe?.contentWindow) return resolve(urlAnterior || null);
        pdf.getBlob((blob) => {
            const url = URL.createObjectURL(blob);
            try {
                iframe.contentWindow.location.replace(url);
            } catch (e) {
                iframe.src = url;
            }
            if (urlAnterior) setTimeout(() => URL.revokeObjectURL(urlAnterior), 1000);
            resolve(url);
        });
    });

// Vista previa de un PDF del CMMS (Orden de Servicio, etiquetas) con descargar e imprimir.
// props.generar: async () => docDefinition de pdfmake.
class ModalPdfCMMS extends Component {
    state = { cargando: false, pdf: null };
    iframeRef = React.createRef();
    urlPdf = null;

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) this.generar();
        if (!this.props.visible && prevProps.visible) this.setState({ pdf: null });
    }

    componentWillUnmount() {
        if (this.urlPdf) URL.revokeObjectURL(this.urlPdf);
    }

    generar = async () => {
        this.setState({ cargando: true, pdf: null });
        try {
            const dd = await this.props.generar();
            if (!dd) return;
            const pdf = pdfMake.createPdf(dd);
            this.setState({ pdf });
            this.urlPdf = await mostrarPdfEnIframe(pdf, this.iframeRef.current, this.urlPdf);
        } catch (error) {
            console.log(error);
            message.error(error?.message || "No se pudo generar el PDF");
        } finally {
            this.setState({ cargando: false });
        }
    };

    render() {
        return (
            <Modal
                className="cmms-modal"
                visible={this.props.visible}
                onCancel={this.props.onClose}
                width={window.innerWidth > 900 ? 980 : "96%"}
                centered
                title={<div className="cmms-modal-titulo-texto">{this.props.titulo}</div>}
                footer={
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <ButtonItem type="default" onClick={this.props.onClose}>
                            Cerrar
                        </ButtonItem>
                        <ButtonItem type="default" icon={<PrinterOutlined />} disabled={!this.state.pdf} onClick={() => this.state.pdf?.print()}>
                            Imprimir
                        </ButtonItem>
                        <ButtonItem type="primary" icon={<DownloadOutlined />} disabled={!this.state.pdf} onClick={() => this.state.pdf?.download(this.props.nombreArchivo || "documento.pdf")}>
                            Descargar
                        </ButtonItem>
                    </div>
                }
            >
                <Spin spinning={this.state.cargando} tip="Generando PDF...">
                    <iframe ref={this.iframeRef} title={this.props.titulo} style={{ width: "100%", height: "72vh", border: 0, background: "#f4f6f9" }} />
                </Spin>
            </Modal>
        );
    }
}

export default ModalPdfCMMS;
